export default __webpack_public_path__ + "static/media/06.b69d6e26.webp";